import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import crypto from 'crypto-js'
// import { Loading } from 'element-ui';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000000 // request timeout
})
let loadingInstance = null

function replaceNewlineWithBr(payload) {
  if (typeof payload === 'string') {
    return payload.replace(/\r\n|\r|\n/g, '<br>')
  }
  if (Array.isArray(payload)) {
    return payload.map(item => replaceNewlineWithBr(item))
  }
  if (payload && typeof payload === 'object') {
    const next = {}
    Object.keys(payload).forEach(key => {
      next[key] = replaceNewlineWithBr(payload[key])
    })
    return next
  }
  return payload
}
// request interceptor
service.interceptors.request.use(
    config => {
      //把参数按abcd排序
      var params ='';
      if(config.method =='post'){
          config.data = replaceNewlineWithBr(config.data)
        params = EUtils.objKeySort(config.data ? config.data : '');
      }else if(config.method =='get'){
        config.params = replaceNewlineWithBr(config.params)
        params = EUtils.objKeySort(config.params ? config.params : '');
      }
      //排序拼接收的数据md5
      var str = params ? crypto.MD5(params).toString() : ''
      //获取时间戳
      var timestamp = Math.floor(new Date().getTime() / 1000);
      // loadingInstance = Loading.service({ fullscreen: true });
      //生成UUID唯一码
      var uuid = EUtils.getCookie('UUID');
      if(!uuid){
        uuid = EUtils.createUuid()
        EUtils.setCookie('UUID',uuid,60*60*60*24*30*30)
      }
      //将参数拼接起来md5获取验证的签名
      var sign = crypto.MD5(timestamp+""+str+"base64:Rtf2e12qlUOTMc/yBQnw1D4x3lAACobYMlu5lHohgP0=").toString()
      config.headers['APP-ID']= '1';
      config.headers['TIMESTAMP']=timestamp;
      config.headers['CLIENT-TYPE']='web';
      config.headers['APP-VERSION']='1.0.0';
      config.headers['CLIENT-MODEL']='web';
      config.headers['UUID']=uuid;
      config.headers['SIGN']=sign;
      if (EUtils.getCookie('Authorization')) {
        config.headers['Authorization'] = EUtils.getCookie('Authorization')
      }
      return config
    },
    error => {
      // loadingInstance.close();
      return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
      const res = response.data
      // loadingInstance.close();
      // if the custom code is not 20000, it is judged as an error.
      if (res.code !== 200) {
        // const error={}
        // error.message = res.message || 'Error'
        // error.code = res.code
        // error.data = res.data
        // return Promise.reject(error)
        if(!response.data.code){
          return res
        }else{
          Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
          // if(res.code == 401 || res.code == 406){
          //   Message({
          //     message: res.message || 'Error',
          //     type: 'error',
          //     duration: 5 * 1000
          //   })
          //   window.location.replace('login');
          // }
        }
        return Promise.reject(res.message || '暂无网络')

      } else {
        return res
      }
    },
    error => {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)

      // 网络错误、超时等
      // if (error.response) {
      //   // 服务器返回了响应（如 500、404）
      //   const { status, data } = error.response
      //   const err = {}
      //   err.status = status
      //   err.data = data
      //   return Promise.reject(err)
      // } else if (error.request) {
      //   // 请求已发出，但无响应（如网络断开）
      //   err.code = 'NETWORK_ERROR'
      //   return Promise.reject(err)
      // } else {
      //   // 其他错误
      //   return Promise.reject(error)
      // }
    }
)

export default service
